import React, { Fragment, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// this is NOT a duplication/mistake from the other one in maps:
// since we aren't doing activePlan, we are using livequery and appId
// we also disable here if it hasn't been downloaded
// the PlanOpt value is appId here, id in the other
// function here manually changes URL, sets activePlan in the other

const PlanOpts = (props) => {
  const { groupId, plans, plots } = props;
  const [list, setList] = useState([]);

  useEffect(() => {
    let filtered = [];
    if(groupId)
      filtered = plans.filter(x => x.planGroupId === groupId && x.status==='A');
    else
      filtered = plans.filter(x => !x.planGroupId && x.status==='A');

    filtered.sort((a,b) => (a.sortOrder > b.sortOrder) ? 1 : ((b.sortOrder > a.sortOrder) ? -1 : 0));
    setList(filtered);
  }, [groupId, plans])

  return (
    <Fragment>
    {list.map(plan => {
        let qty = plots?.filter(x => x.planId === plan.id)?.length;
        return (
          <option key={`plan-${plan.id}`} value={plan.appId} disabled={!plan.lastSync}>
            {plan.name}
            {qty > 0 && ` - ${qty} plots`}
          </option>
        )
      })}
    </Fragment>
  );
}

const View = (props) => {
  const params = useParams();
  const navigate = useNavigate();
  const { planGroups, plans, plots } = props;

  const changePlan = (e) => {
    e.target.blur();
    navigate(`../${e.target.value}`);
  }

  // don't show this if there aren't multiple plans
  if(plans.length < 2) return null;

  return (
    <select
      style={{width:200}}
      className="form-select form-select-lg d-inline-block border shadow-sm float-end me-2"
      value={params.planId}
      onChange={changePlan}>
        {planGroups.filter(x => x.status === 'A')
          .sort((a,b) => (a.sortOrder > b.sortOrder) ? 1 : ((b.sortOrder > a.sortOrder) ? -1 : 0))
          .map(group => (
            <optgroup key={`group-${group.id}`} label={group.name}>
              <PlanOpts groupId={group.id} plans={plans} plots={plots} />
            </optgroup>
        ))}
        
        {/* only show the dashes if there are grouped plans */}
        {(planGroups.filter(x => x.status === 'A').length > 0 &&
          plans.filter(x => !x.planGroupId && x.status==='A').length > 0) && (
          <optgroup label="--">
            <PlanOpts plans={plans} plots={plots} />
          </optgroup>
        )}

        {/* otherwise just show them not in an opt group */}
        {planGroups.filter(x => x.status === 'A').length === 0 && (
          <PlanOpts plans={plans} plots={plots} />
        )}
    </select>
  )
}

export default View;
